module.exports = __webpack_public_path__ + "img/292156477.fd099568.jpg";